<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <h2 class="headline">
          <span class="font-weight-bold d-flex align-center">
            <v-icon class="mr-3 black--text" @click="goBack()">mdi-arrow-left</v-icon>
            {{ $t('forget_password') }}
          </span>
        </h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">
          <v-form>
            <l-a-phone-number v-model="form.phone" :label="$t('fields.phone')" />
          </v-form>
          <p class="text-note">
            {{ $t('we_will_send_a_verification_code_to_reset_the_password') }}
          </p>
          <v-btn color="primary" x-large block class="text-none" @click="forgetPassword()">
            {{ $t('next_3') }}
          </v-btn>
        </ValidationObserver>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  forgotPass as forgotPassCustomer
} from '@/api/auth'
import {
  ValidationObserver
} from 'vee-validate'
import LAPhoneNumber from '@/components/modules/LAphone/Index'
export default {
  components: {
    LAPhoneNumber,
    ValidationObserver
  },
  data() {
    return {
      form: {
        phone: '',
        otp_type: 2
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    async forgetPassword() {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        try {
          const { data } = await forgotPassCustomer(this.form)
          this.$store.state.loading_axios = false
          data.data.expiry_otp = new Date(new Date().getTime() + 2 * 60000)
          const data_verify = {
            key_pre_register: '',
            value: data.data
          }
          this.$store.dispatch('data_verification', data_verify)
          this.$store.dispatch('save_type_verification', 'call')
          this.$router.push({ name: 'forget_verification_otp' }).catch(() => {})
        } catch (e) {
          this.$store.state.show_error = true
          this.$store.state.error_message = e.string
          this.$store.state.error_type = e.statusCode
        }
      }
    }
  }
}
</script>
